$(function() {

  'use strict';

  var _this,
      _window = $(window);

  $(function() {
    _window.on('load', function() {
      $('#news .js-matchHeight-wrapper').find('.date').matchHeight();
      $('#news .js-matchHeight-wrapper').find('.title').matchHeight();
      $('#news .js-matchHeight-wrapper').find('.category').matchHeight();
      $('#news .js-matchHeight-wrapper').find('.text').matchHeight();
    });
  });

});
